import * as ActionTypes from 'actions/ActionTypes'

export const deleteTask = (taskId, isLoading = undefined) => ({
  type: ActionTypes.DELETE_EDITING_TASK,
  payload: { taskId, isLoading },
})

export const deleteTaskError = err => ({
  type: ActionTypes.DELETE_EDITING_TASK,
  payload: { err },
  error: true,
})
